//@flow
export const connectivityActionTypes = {
  ON_NETWORK_CONNECTION_CHANGED: "ON_NETWORK_CONNECTION_CHANGED"
};

export type ConnectivityActionType = $Keys<typeof connectivityActionTypes>;
